export default {
  //columnName
  columnName: {
    name: "Name",
    storenumber: "Store Number",
    storename: "Store Name",
    terminalnumber: "Terminal Number",
    terminalname: "Terminal Name",
    foodkindnumber: "Food Kind Number",
    foodkindname: "Food Kind Name",
    onlineordercategoryname: "Online Order Category Name",
    foodmajorkindnumber: "Food Major Kind Number",
    foodmajorkindname: "Food Major Kind Name",
    barcode: "Barcode",
    barcode2: "Barcode 2",
    barcode3: "Barcode 3",
    departmentnumber: "Department Number",
    departmentname: "Department Name",
    foodnumber: "Food Number",
    onlineorderitemname: "Online Order Item Name",
    foodname: "Food Name",
    foodname2: "Food Name 2",
    foodmemo: "Memo",
    qty: "Qty",
    safeqty: "Safe Qty",
    lackqty: "Lack Qty",
    pickedqty: "Picked Qty",
    notpickedqty: "Not Picked Qty",
    salprice: "Sale Price",
    salprice1: "Sale Price 1",
    salprice2: "Sale Price 2",
    salprice3: "Sale Price 3",
    salprice4: "Sale Price 4",
    salprice5: "Sale Price 5",
    salprice6: "Sale Price 6",
    discountsalprice: "Discount Sale Price",
    cost: "Cost",
    totalcost: "Total Cost",
    avgcost: "Avg Cost",
    totalavgcost: "Total Avg Cost",
    differencetotalcost: "Difference Total Cost",
    differencetotal: "Difference Total",
    grossprofit: "Gross Profit",
    profit: "Profit",
    grossmargin: "Gross Margin",
    foodsaleproportion: "Food Sale Proportion",
    saleproportion: "Sale Proportion",
    total: "Total",
    saltotal: "All Total",
    alltotal: "All Total",
    saletotal: "Sale Total",
    salereturntotal: "Sale Return Total",
    totaldiscountprice: "Total Discount Price",
    saletotaldiscountprice: "Sale Total Discount Price",
    discountprice: "Discount Price",
    totalfreeprice: "Total Free Price",
    freeprice: "Free Price",
    unit: "Unit",
    employeenumber: "Employee Number",
    employeename: "Employee Name",
    salernumber: "Salesperson Number",
    salername: "Salesperson Name",
    warehousenumber: "Warehouse Number",
    warehousename: "Warehouse Name",
    fromwarehousenumber: "From Warehouse Number",
    fromwarehousename: "From Warehouse Name",
    towarehousenumber: "To Warehouse Number",
    towarehousename: "To Warehouse Name",
    suppliernumber: "Supplier Number",
    suppliername: "Supplier Name",
    purchasetotal: "Purchase Total",
    purchasereturntotal: "Purchase Return Total",
    salefoodname: "Sale Food Name",
    customernumber: "Customer Number",
    customerid: "Customer Number",
    customername: "Customer Name",
    email: "Email",
    telephone: "Telephone",
    cellphone: "Cellphone",
    memo: "Memo",
    tradememo: "Trade Memo",
    salmemo: "Sale Memo",
    gender: "Gender",
    username: "User Name",
    roletype: "Role Type",
    businessid: "Business ID",
    businessname: "Business Name",
    combokindname: "Combo Kind Name",
    comboname: "Combo Name",
    tastekindname: "Taste Kind Name",
    onlineordermodifiergroupname: "Online Order Modifier Group Name",
    tastename: "Taste Name",
    onlineordermodifiername: "Online Order Modifier Name",
    price: "Price",
    invoicedate: "Invoice Date",
    invoicenumber: "Invoice Number",
    period: "Period",
    postalcode: "Postal Code",
    address: "Address",
    phone: "Phone",
    invoiceemail: "Invoice Email",
    invoiceprizetype: "Invoice Prize Type",
    invoiceprizeamount: "Invoice Prize Amount",
    invoiceprizenumber: "Invoice Prize Number",
    businessnumber: "Business Number",
    purchasenumber: "Purchase Number",
    purchaseordernumber: "Purchase Order Number",
    salnumber: "Sale Number",
    tradenumber: "Trade Number",
    depositrecordnumber: "Deposit Record Number",
    purchasedate: "Purchase Date",
    businessday: "Business Day",
    businessclass: "Business Class",
    stockadjustnumber: "Stock Adjust Number",
    stockadjustdate: "Stock Adjust Date",
    fromstockadjustnumber: "From Stock Adjust Number",
    tostockadjustnumber: "To Stock Adjust Number",
    stocktransfernumber: "Stock Transfer Number",
    stocktransferdate: "Stock Transfer Date",
    checkqty: "Check Qty",
    checkername: "Checker Name",
    buildername: "Builder Name",
    paytype: "Pay Type",
    payname: "Pay Name",
    salepaytype: "Pay Type",
    functionname: "Function Name",
    functionshowname: "Function Name",
    functiontypetext: "Function Type",
    value: "Value",
    directorytype: "Directory Type",
    directorytypetext: "Directory Type",
    directorykindname: "Directory Kind Name",
    directoryname: "Directory Name",
    moduletype: "Module Type",
    modulename: "Module Name",
    promotionname: "Promotion Name",
    promotiondetname: "Promotion Det Name",
    buyernumber: "Buyer Number",
    buyername: "Buyer Name",
    receiptnumber: "Receipt Number",
    receiptdate: "Receipt Date",
    paymentnumber: "Payment Number",
    paymentdate: "Payment Date",
    tradetype: "Trade Type",
    tradetypetext: "Trade Type",
    eattype: "Eat Type",
    eattypetext: "Eat Type",
    payable: "Payable",
    payed: "Payed",
    nopay: "No Pay",
    accountdate: "Account Date",
    receivable: "Receivable",
    received: "Received",
    downloadname: "Download Name",
    counts: "Counts",
    salecounts: "Sale Counts",
    voidcounts: "Void Counts",
    foodcounts: "Food Counts",
    foodaveragesalprice: "Food Average Sal Price ",
    totalperreceipt: "Total Per Receipt",
    foodcountsperreceipt: "Food Counts Per Receipt",
    peopleperreceipt: "People Per Receipt",
    totalperperson: "Total Per Person",
    foodcountsperperson: "Food Counts Per Person",
    people: "People",
    time: "Time",
    times: "Times",
    invoicebegin: "Invoice Begin",
    invoiceend: "Invoice End",
    ytaxprice: "Taxable Amount",
    taxprice: "Tax Amount",
    ytaxpriceincludetax: "Price Including Tax",
    ztaxprice: "Zero Tax Amount",
    ntaxprice: "No Tax Amount",
    netprice: "Net Amount",
    difference: "Difference",
    sheets: "Sheets",
    invoicevoid: "Invoice Void",
    voidsheets: "Void Sheets",
    saltime: "Sale Time",
    invoicetime: "Invoice Time",
    deliverytime: "Delivery Time",
    tradetime: "Trade Time",
    createtime: "Create Time",
    updatetime: "Update Time",
    cash: "Cash",
    change: "Change",
    uniformnumber: "Uniform Number",
    inventorydate: "Inventory Date",
    inventorynumber: "Inventory Number",
    inventoryqty: "Inventory Qty",
    stockqty: "Stock Qty",
    initialqty: "Initial Qty",
    lastqty: "Last Qty",
    salqty: "Sale Qty",
    voidsalqty: "Void Sale Qty",
    purchaseqty: "Purchase Qty",
    purchaseprice: "Purchase Price",
    purchasereturnqty: "Purchase Return Qty",
    adjustqty: "Adjust Qty",
    combinationinqty: "Combination In Qty",
    combinationoutqty: "Combination Out Qty",
    seperationinqty: "Separation In Qty",
    seperationoutqty: "Separation Out Qty",
    transferinqty: "Transfer In Qty",
    transferoutqty: "Transfer Out Qty",
    tradedate: "Trade Date",
    deviceid: "Device ID",
    devicename: "Device Name",
    cpuid: "CUP ID",
    statustype: "Status Type",
    statustypetext: "Status Type",
    principlenumber: "Principle Number",
    principlename: "Principle Name",
    daybegin: "Day Begin",
    dayend: "Day End",
    timebegin: "Time Begin",
    timeend: "Time End",
    sunday: "Sunday",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    daymodulename: "Day Module Name",
    integral: "Integral",
    integraladd: "Integral Add",
    integralminus: "Integral Minus",
    birth: "Birth",
    degree: "Degree",
    degreetext: "Degree",
    memberlabel: "Member Label",
    customerleveltypetext: "Customer Level Type",
    days: "Days",
    memberupgraderule: "Member Upgrade Rule",
    memberupgraderuletext: "Degree",
    creditcardprice: "Credit Card Price",
    creditcardnumber: "Credit Card Number",
    paytype1: "Pay Type 1",
    paytype2: "Pay Type 2",
    linepay: "LINE Pay",
    linepayprice: "LINE Pay",
    scan2pay: "Scan2Pay",
    scan2payprice: "Scan2Pay",
    pxpayprice: "PXPay",
    couponprice: "Coupon Price",
    deposit: "Deposit",
    depositminus: "Deposit Minus",
    lastrechargeamount: "Last Recharge Amount",
    executetime: "Execute Time",
    easycardprice: "Easy Card Price",
    number: "Number",
    overcharge: "Over Charge",
    originalprice: "Original Price",
    originaltotal: "Original Total",
    originalqty: "Original Qty",
    identifier: "Identifier",
    totallength: "Total Length",
    pricelabeltype: "Price Label Type",
    foodposition: "Food Position",
    foodlength: "Food Length",
    priceposition: "Price Position",
    pricelength: "Price Length",
    pricedecimalnumber: "Price Decimal Number",
    qtyposition: "Qty Position",
    qtylength: "Qty Length",
    qtydecimalnumber: "Qty Decimal Number",
    discount: "Discount",
    towork: "To Work",
    offwork: "Off Work",
    worktime: "Work Time",
    worktimehour: "Work Time Hour",
    worktimeminute: "Work Time Minute",
    devicecounts: "Device Counts",
    principle: "Principle",
    contactperson: "Contact Person",
    faxnumber: "Fax Num",
    startdate: "Start Date",
    enddate: "End Date",
    months: "Months",
    monthlyfee: "Monthly Fee",
    freedeposit: "Free Deposit",
    beforedeposit: "Before Deposit",
    afterdeposit: "After Deposit",
    beforestock: "Before Stock",
    peopletype1: "People Type 1",
    peopletype2: "People Type 2",
    peopletype3: "People Type 3",
    peopletype4: "People Type 4",
    totalpeople: "Total People",
    lywarehousenumber: "LY Warehouse Number",
    lyuniformnumber: "LY Uniform Number",
    vehiclenumber: "Vehicle Number",
    originalinvoice: "Original Invoice",
    modulestorename: "Module Store Name",
    isfinalpaymentpayed: "Is Final Payment Payed",
    isadvancedpayed: "Is Advance Payed",
    finalpayment: "Final Payment",
    finalpaymentdate: "Final Payment Date",
    advanceddeposit: "Advanced Deposit",
    advanceddepositnumber: "Advanced Deposit Number",
    finalpaymentnumber: "Final Payment Number",
    producttype: "Product Type",
    producttypetext: "Product Type",
    accountnumber: "Account Number",
    accountname: "Account Name",
    couponname: "Coupon Name",
    expiredate: "Expire Date",
    sourcesalnumber: "Source Sale Number",
    sourcesaltime: "Source Sale Time",
    sourceterminalnumber: "Source Terminal Number",
    sourceterminalname: "Source Terminal Name",
    discountsalnumber: "Discount Sale Number",
    discountsaltime: "Discount Sale Time",
    discountterminalnumber: "Discount Terminal Number",
    discountterminalname: "Discount Terminal Name",
    onlineorderstorename: "Online Order Store Name",
    onlineorderphone: "Online Order Phone",
    onlineorderaddress: "Online Order Address",
    collectionpaymenttype: "Collection Payment Type",
    onlineordermenuname: "Online Order Menu Name",
    minqty: "Min Qty",
    maxqty: "Max Qty",
    taxtype: "Tax Type",
    taxtypetext: "Tax Type",
    starttime: "Start Time",
    endtime: "End Time",
    combinationtradedate: "Combination Trade Date",
    combinationtradenumber: "Combination Trade Number",
    seperationtradedate: "Separation Trade Date",
    seperationtradenumber: "Separation Trade Number",
    combinationwarehousenumber: "Combination Warehouse Number",
    combinationwarehousename: "Combination Warehouse Name",
    combinationfoodnumber: "Combination Food Number",
    combinationfoodname: "Combination Food Name",
    combinationqty: "Combination Qty",
    combinationtotal: "Combination Total",
    combinationunit: "Combination Unit",
    stockadjusttype: "Stock Adjust Type",
    stockadjusttypetext: "Stock Adjust Type",
    promotiontype: "Promotion Type",
    promotiontypetext: "Promotion Type",
    balance: "Balance",
    ocardruleid: "Ocard Rule ID",
    ocardrulename: "Ocard Rule Name",
    ocardpromotiontype: "Ocard Promotion Type",
    ocardpromotiontypetext: "Ocard Promotion Type",
    ocardrulefoodnametext: "Ocard Rule Food Name",
    promotionvalue: "Promotion Value",
    salesperson: "Salesperson",
    partner: "Partner",
    utailocationtype: "Utai Location Type",
    utailocationtypetext: "Utai Location Type",
    applytype: "Apply Type",
    applytypetext: "Apply Type",
    termleasetype: "Term Lease Type",
    termleasetypetext: "Term Lease Type",
    companyname: "Company Name",
    companypostalcode: "Company Postal Code",
    companyaddress: "Company Address",
    taxnumber: "Tax Number",
    taxationbureau: "Taxation Bureau",
    storepostalcode: "Store Postal Code",
    storeaddress: "Store Address",
    principalname: "Principal Name",
    principalphone: "Principal Phone",
    principalfax: "Principal Fax",
    principalemail: "Principal Email",
    contactpersonphone: "Contact Person Phone",
    contactpersonfax: "Contact Person Fax",
    contactpersonemail: "Contact Person Email",
    invoicesheets: "Invoice Sheets",
    invoiceincreasesheets: "Invoice Increase Sheets",
    maingoods: "Main Goods",
    receiver: "Receiver",
    receiveraddress: "Receiver Address",
    receivertelephone: "Receiver Telephone",
    receiverphone: "Receiver Cellphone",
    applicationid: "Application ID",
    ishead: "Is Head",
    isheadtext: "Is Head",
    extraprice: "Extra Price",
    isselect: "Is Select",
    add: "Add",
    remove: "Remove",
    pricemarkup: "Price Markup",
    alladd: "All Add",
    min: "Min",
    max: "Max",
    use: "Use",
    delete: "Delete",
    fullnumber: "Full",
    isrepeat: "Is Repeat",
    modify: "Modify",
    isvoid: "Is Void",
    changestatus: "Change Status",
    status: "Status",
    select: "Select",
    selectall: "Select All",
    item: "Item",
    isinvoicehassend: "Is Invoice Has Send",
    iselecinvoicesendemail: "Invoice Email Status",
    isinvoicehasprint: "Is Invoice Has Print",
    pgtalkprice: "PGTalk",
    pgtalkpt: "PGTalk PT",
    validmonths: "Valid Months",
    keeptotal: "Keep Total",
    keepmonths: "Keep Months",
    visiontype: "Vision Type",
    visiontypetext: "Vision Type",
    builddate: "Build Date",
    batchnumber: "Batch Number",
    phone1: "Phone 1",
    phone2: "Phone 2",
    changepricetype: "Change Price",
    changepricetypetext: "Change Price",
    salpricetype: "Sale Price",
    salpricetypetext: "Sale Price",
    hasbatchnumber: "Has Batch Number",
    purchaseorderqty: "Purchase Order Qty",
    saleorderqty: "Sale Order Qty",
    sequence: "Sequence",
    agencystartdate: "Agency Start Date",
    availablyqty: "Availably Qty",
    downloaditemname: "Download Item Name",
    issuccess: "Is Success",
    issuccesstext: "Is Success",
    onlineordermenu: "Menu",
    onlineordermenutext: "Menu",
    degreestartdate: "Degree Start Date",
    degreeenddate: "Degree End Date",
    specificationtypename: "Specification Type Name",
    specificationname: "Specification Name",
    terminalid: "Terminal ID",
    apitype: "API Type",
    apitypetext: "API Type",
    requesturl: "Request URL",
    requestmethod: "Request Method",
    responsecode: "Response Code",
    issucccess: "Is Success",
    durationtime: "Duration Time",
    requesttime: "Request Time",
    thirdpartytype: "Third Party Type",
    thirdpartytypetext: "Third Party Type",
    httpmethod: "HTTP Method",
    durationseconds: "Duration Seconds",
    userid: "User ID",
    systemlogtype: "System Log Type",
    systemlogtypetext: "System Log Type",
    description: "Description",
    requestcontent: "Request Content",
    responsecontent: "Response Content",
    requestbody: "Request Body",
    notificationtype: "Notification Type",
    notificationtypetext: "Notification Type",
    orderid: "Order ID",
    lastnotificationtime: "Last Notification Time",
    resendtimes: "Resend Times",
    webhooklogid: "Webhook Log ID",
    webhooktype: "Webhook Type",
    webhooktypetext: "Webhook Type",
    clientip: "Client IP",
    transactionid: "Transaction ID",
    errormsg: "Error MSG",
    signature: "Signature",
    id: "ID",
    apptype: "App Type",
    floormapid: "Floor Map ID",
    tablemapid: "Table Map ID",
    tablemapname: "Table Map Name",
    partid: "Part ID",
    index: "Index",
    body: "Body",
    thirdpartybody: "Third Party Body",
    authcode: "Auth Code",
    cardnumber: "Card Number",
    creditcardtradenumber: "Credit Card Trade Number",
    brandname: "Brand Name",
    brandnumber: "Brand Number",
    broadcastid: "Broadcast Id",
    version: "Version",
    ubereats: "UberEats",
    ubereatsprice: "UberEats",
    purchasememo: "Purchase Memo",
    originalsalnumber: "Original Sale Number",
    retailprice: "Retail Price",
    iserp: "Is ERP",
    isdining: "Is Dining",
    industrytypetext: "Industry Type",
    promotionmodetype: "Promotion Mode Type",
    promotionmodetypetext: "Promotion Mode Type",
    actualsaleqty: "Actual Sale Qty",
    istoworkrepair: "Is To Work Repair",
    istoworkrepairtext: "Is To Work Repair",
    isoffworkrepair: "Is Off Work Repair",
    isoffworkrepairtext: "Is Off Work Repair",
    creditcardpaytype: "Credit Card Pay Type",
    creditcardpaytypetext: "Credit Card Pay Type",
    ipassprice: "iPASS Price",
    ipassmoneyprice: "iPASS Money Price",
    jkopayprice: "JKO Pay Price",
    twpayprice: "TW Pay Price",
    piwalletprice: "Pi Wallet Price",
    easywalletprice: "Easy Wallet Price",
    openemployeenumber: "Open Employee Number",
    openemployeename: "Open Employee Name",
    closeemployeenumber: "Close Employee Number",
    closeemployeename: "Close Employee Name",
    opentime: "Open Time",
    closetime: "Close Time",
    opencash: "Open Cash",
    closecash: "Close Cash",
    closeqty1000: "Close Qty 1000",
    closeqty500: "Close Qty 500",
    closeqty100: "Close Qty 100",
    closeqty50: "Close Qty 50",
    closeqty10: "Close Qty 10",
    closeqty5: "Close Qty 5",
    closeqty1: "Close Qty 1",
    cashdiffer: "Cash Differ",
    cashdiffermemo: "Cash Differ Memo",
    closecreditcardprice: "Close Credit Card Price",
    creditcarddiffer: "Credit Card Differ",
    creditcarddiffermemo: "Credit Card Differ Memo",
    closepaytype1: "Close PayType1",
    closepaytype1price: "PayType1 Differ",
    paytype1differmemo: "PayType1 Differ Memo",
    closepaytype2: "Close PayType2",
    closepaytype2price: "PayType2 Differ",
    paytype2differmemo: "PayType2 Differ Memo",
    closelinepayprice: "Close LINE Pay Price",
    linepaydiffer: "LINE Pay Differ",
    linepaydiffermemo: "LINE Pay Differ Memo",
    closepxpayprice: "Close PXPay Price",
    pxpaydiffer: "PXPay Differ",
    pxpaydiffermemo: "PXPay Differ Memo",
    closejkopayprice: "Close JKOPay Price",
    jkopaydiffer: "JKOPay Differ",
    jkopaydiffermemo: "JKOPay Differ Memo",
    closecollection: "Close Collection",
    collectiondiffer: "Collection Differ",
    collectiondiffermemo: "Collection Differ Memo",
    closepayment: "Close Payment",
    paymentdiffer: "Payment Differ",
    paymentdiffermemo: "Payment Differ Memo",
    requiredqty: "Required Qty",
    upperlimitqty: "Upper Limit Qty",
    dailylimitqty: "Daily Limit Qty",
    batchnumberposition: "Batch Number Position",
    batchnumberlength: "Batch Number Length",
    showprice: "Price",
    orderstatustype: "Order Status",
    totalspent: "Total Spent",
    paytypename: "Pay Type Name",
    holidaytime: "Time",
    active: "Active",
    giftvouchernumber: "Gift Voucher Number",
    giftvouchername: "Gift Voucher Name",
    foodstocktype: "Food Stock Type",
    incounts: "In Store Counts",
    intotal: "In Store Total",
    outcounts: "Take Out Counts",
    outtotal: "Take Out Total",
    deliverycounts: "Delivery Counts",
    deliverytotal: "Delivery Total",
    pickselfcounts: "Pick Self Counts",
    pickselftotal: "Pick Self Total",
    sendcountformatted: "Send Count",
    sendpointformatted: "Send Point",
    descriptioncondition: "Description Condition",
    suggestprice: "Suggest Price",
    integralgettotal: "Integral Total",
    integralget: "Get Integral",
    freeqty: "Free Qty",
    statustext: "Status",
    pickupname: "Pickup Name",
    pickupnumber: "Pickup Number",
    pickuptype: "Pickup Type",
    pickuptypetext: "Pickup Type",
    erpplatformnumber: "ERP Platform Number",
    relateddocuments: "Related Documents",
    saltype: "Sale Type",
    saltypetext: "Sale Type",
    totaladjustment: "Total Adjustment",
    uploadtype: "Upload Log Type",
    uploadtypetext: "Upload Log Type",
    successcount: "Success Count",
    failcount: "Fail Count",
    targetno: "Target Number",
    resultmessage: "Result Message",
    uploadlogdetail: "Upload Log Detail",
    foodfreeprice: "Food Free Price",
    nationality: "Nationality",
    nationalitynumber: "Nationality Number",
    nationalityname: "Nationality Name",
    calories: "Calories",
    duration: "Duration",
    foodTaxType: "Food Tax Type",
    salecost: "Sale Cost",
    foodsalestatustype: "Food Sale Status",
    ordercounts: "Order Counts",
    iserpplatformupload: "ERP Platform Upload",
    summary: "Summary",
    foodtaxtype: "Food Tax Type",
    transactiontype: "Transaction Type",
    transactiontime: "Transaction Time",
    requisitionnumber: "Requisition Number",
    requisitiondate: "Requisition Date",
    desireddeliverydate: "Desired Delivery Date",
    saleqty: "Sale Qty",
    suggestrestockqty: "Suggest Restock Qty",
    initialtotalcost: "Initial Total Cost",
    purchasetotalcost: "Purchase Total Cost",
    purchasereturntotalcost: "Purchase Return Total Cost",
    stockadjusttotalcost: "Stock Adjust Total Cost",
    lastcost: "Last Cost",
    dailyaveragesaleqty: "Daily Average Sale Qty",
    purta200: "Purta200",
    purta003: "Purta003",
    department: "Department",
    creator: "Creator",
    integralfreeamount: "Integral Free Amount",
    foodprice: "Price",
    hardwareid: "HardwareId",
    islicensegenerated: "Is License Generated",
    kdsserverip: "Server IP",
    logintime: "Login Time",
    logouttime: "Logout Time",
    loginip: "Login IP",
  },
  //columnName
  modalTitle: {
    defaultTitle: "Setting",
    addShortCut: "Add Shortcut",
  },
  modalButton: {
    done: "Done",
    cancel: "Cancel",
    select: "Select",
  },
  message: {
    hello: "Hello World",
  },

  //enums
  enums: {
    dateRange: {
      today: "Today",
      yesterday: "Yesterday",
      thisWeek: "This Week",
      thisMonth: "This Month",
      lastMonth: "Last Month",
      thisYear: "This Year",
      lastYear: "Last Year",
      lastSevenDays: "Last 7 Days",
      lastThirtyDays: "Last 30 Days",
      customize: "Customize",
    },
    taxType: {
      All: "All",
      NoInvoice: "No Invoice",
      YTax: "Including Tax",
      ZTax: "Zero Tax",
      NTax: "No Tax",
    },
    reportSource: {
      All: "All",
      Local: "POS",
      Web: "Web",
      Ubereats: "UberEats",
      Backstage: "Backstage",
      Showmore: "Showmore",
    },
    costType: {
      NormalCost: "Normal Cost",
      AvgCost: "Avg Cost",
      LastCost: "Last Cost",
    },
    eatSearchType: {
      All: "All",
      In: "In",
      Out: "Out",
      Delivery: "Delivery",
      InAndOut: "In And Out",
      InAndDelivery: "In And Delivery",
      OutAndDelivery: "Out And Delivery",
      PickSelf: "PickSelf",
      InAndPickSelf: "In And Pick Self",
      OutAndPickSelf: "Out And Pick Sekf",
      DeliveryAndPickSelf: "Delivery And Pick Self",
      InAndOutAndDelivery: "In And Out And Delivery",
      InAndOutAndPickSelf: "In And Out And Pick Self",
      InAndDeliveryAndPickSelf: "In And Delivery And Pick Self",
      OutAndDeliveryAndPickSelf: "Out And Delivery And Pick Self",
    },
    foodStatusType: {
      All: "All",
      Normal: "Normal",
      Discontinued: "Discontinued",
    },
    rankType: {
      None: "None",
      Qty: "Qty",
      Total: "Total",
    },
    businessClassType: {
      All: "All",
    },
    visionType: {
      Myopia: "Myopia",
      Hyperopia: "Hyperopia",
      Contacts: "Contacts",
      Other: "Other",
      Multifocal: "Multifocal",
    },
  },
  //enums

  //modal
  modal: {
    purchasenumber: "Purchase Number",
  },
  //modal
};
